import React, { Children } from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CoreBeliefs() {
  const beliefs = [{
    title: 'Recruiting is a Factory, Not a Casino.',
    description: 'Stop treating hiring like a gamble. It should be structured, predictable, and measurable.',
    points: ['Structured', 'Predictable', 'Measurable', 'Repeatable'],
    closing: 'A good system removes the stress.'
  }, {
    title: 'Retention Starts Before Day One.',
    description: "Reps don't quit because the job is hard. They quit because they are confused. You recruit the curious and develop the committed.",
    points: ['The first 8 weeks matter most', 'Structure beats motivation', 'Culture must be designed, not assumed'],
    closing: 'We fix the clarity, so you keep the rep.'
  }, {
    title: 'Partners, Not Vendors.',
    description: "We don't just send you leads. We help you install the machine into your business.",
    points: ['Strategy matters', 'Feedback matters', 'Leadership matters', 'Consistency matters'],
    closing: 'We work with you.'
  }];
  const whatWeDont = ['We don\'t sell "magic bullets."', "We don't promise results we can't control.", "We don't work with leaders who refuse to change.", "We don't treat this like a short-term gig."];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section className="section-padding bg-gray-50" data-id="element-148">
      <div className="container-custom" data-id="element-149">
        <motion.div className="max-w-4xl mx-auto text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} data-id="element-150">
          <h2 className="mb-6" data-id="element-151">How We Think</h2>
          <p className="text-body-large leading-relaxed" data-id="element-152">
            These are the rules we operate by.
          </p>
        </motion.div>

        {/* Beliefs */}
        <motion.div className="max-w-5xl mx-auto space-y-8 mb-16" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-153">
          {beliefs.map((belief, index) => <motion.div key={index} className="bg-white rounded-xl p-8 shadow-lg border-l-4 border-slate" variants={itemVariants} data-id="element-154">
              <h3 className="mb-4" data-id="element-155">{belief.title}</h3>
              <p className="leading-relaxed mb-4" data-id="element-156">{belief.description}</p>
              <div className="bg-gray-50 rounded-lg p-6 mb-4" data-id="element-157">
                <ul className="space-y-2" data-id="element-158">
                  {belief.points.map((point, idx) => <li key={idx} className="flex items-center" data-id="element-159">
                      <CheckCircleIcon className="h-5 w-5 text-slate flex-shrink-0 mr-3" data-id="element-160" />
                      {point}
                    </li>)}
                </ul>
              </div>
              <p className="italic" data-id="element-161">{belief.closing}</p>
            </motion.div>)}
        </motion.div>

        {/* What We Don't Do */}
        <motion.div className="max-w-4xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-162">
          <h3 className="text-center mb-8" data-id="element-163">What We Don't Do</h3>
          <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-200" data-id="element-164">
            <ul className="space-y-4" data-id="element-165">
              {whatWeDont.map((item, index) => <li key={index} className="flex items-start" data-id="element-166">
                  <XCircleIcon className="h-6 w-6 text-gray-400 flex-shrink-0 mr-3 mt-1" data-id="element-167" />
                  <span data-id="element-168">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}